import { h } from 'preact';
import LoadingDots from './LoadingDots';
import { useText } from 'preact-i18n';

const SigninJoinCard = ({ buttonText, isLoading, onClick }) => {
  const { doters_points, travel_doters, gain } = useText({
    doters_points: 'label.doters_points',
    travel_doters: 'label.travel_doters',
    gain: 'label.gain',
  });

  return (
    <div className="join-card" onClick={onClick} title={buttonText}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <i className="doters-logo-black" />
        <div className="divider" />
        <p className="join-card-message">
          {gain}
          <b>{doters_points}</b>
          {`${travel_doters}!`}
        </p>
      </div>

      {isLoading ? (
        <LoadingDots />
      ) : (
        <button type="button" className="join-card-button" onClick={onClick}>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default SigninJoinCard;
